function openPopup(url, title, w = 600, h = 450) {
    const left = (screen.width / 2) - (w / 2);
    const top = (screen.height / 2) - (h / 2);
    window.open(url, title, `width=${w},height=${h},top=${top},left=${left},resizable=yes,scrollbars=yes`);
}

function buildShareUrl(platform, pageUrl, pageTitle) {
    pageUrl = encodeURIComponent(pageUrl);
    pageTitle = encodeURIComponent(pageTitle);
    switch (platform) {
        case 'facebook':
            return 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
        case 'x':
            return 'https://x.com/intent/tweet?text=' + pageTitle + '&url=' + pageUrl;
        case 'dribbble':
            return 'https://dribbble.com/';
        case 'instagram':
            return 'https://www.instagram.com/';
        default:
            return '';
    }
}

function handleShareClick(e) {
    const btn = e.target.closest('.share-btn');
    if (!btn) return;
    const platform = btn.getAttribute('data-platform');
    const url = btn.getAttribute('data-url') || window.location.href;
    const title = btn.getAttribute('data-title') || document.title;

    // Use Web Share API if available
    if (navigator.share && (platform === 'x' || platform === 'facebook')) {
        navigator.share({ title: decodeURIComponent(title), url: url }).catch(() => {});
        return;
    }

    const shareUrl = buildShareUrl(platform, url, title);
    if (shareUrl) openPopup(shareUrl, 'Share', 650, 450);
}

export default function shareHook() {
    document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.share-btn')) {
            e.preventDefault();
            handleShareClick(e);
        }
    });
}